module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('v-popover', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "offset": "16",
      "options": _vm.options,
      "open": _vm.show,
      "placement": "left"
    }
  }, [_c('button', {
    staticClass: "tooltip-target b3",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "mouseover": function($event) {
        _vm.show = true
      },
      "mouseleave": function($event) {
        _vm.show = false
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-calculator fa-fw"
  })]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticStyle: {
      "background": "#172b43",
      "color": "#fff",
      "padding": "5px 10px",
      "text-align": "center",
      "margin-bottom": "10px",
      "border-radius": "4px"
    }
  }, [_c('b', [_vm._v("BUDGET")])]), _vm._v(" "), _c('div', {
    staticClass: "line good"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Forv. omsætning")]), _vm._v(" "), _c('div', {
    staticClass: "right good"
  }, [_vm._v(_vm._s(_vm._f("realCurrency")(_vm.project.calculation_price ? _vm.project.calculation_price : 0)))])]), _vm._v(" "), _c('div', {
    staticClass: "line bad"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Forv. kostpris")]), _vm._v(" "), _c('div', {
    staticClass: "right bad"
  }, [_vm._v(_vm._s(_vm._f("realCurrency")(_vm.project.calculation_cost ? _vm.project.calculation_cost : 0)))])]), _vm._v(" "), _c('div', {
    staticClass: "divider",
    staticStyle: {
      "margin": "10px 0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line total"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Forv. dækningsbidrag")]), _vm._v(" "), _c('div', {
    staticClass: "right",
    class: {
      'good': _vm.project.calculation_coverage > 0, 'bad': _vm.project.calculation_coverage < 0
    }
  }, [_vm._v(_vm._s(_vm._f("realCurrency")(_vm.project.calculation_coverage ? _vm.project.calculation_coverage : 0)))])])])], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-804e69b6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-804e69b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/BudgetTooltip.vue
// module id = 867
// module chunks = 0